(function () {
  if (customElements.get('bundle-swatch-select')) return;

  class BundleSwatchSelect extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('[data-trigger]');
      this.list = this.querySelector('[data-options]');
      this.dot = this.querySelector('[data-dot]');
      this.value = this.querySelector('[data-value]');

      this.trigger.addEventListener('click', () => this.toggle());
      this.list.addEventListener('click', (event) => {
        const option = event.target.closest('[data-option]');
        if (option) this.select(option);
      });
      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) this.close();
      });
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.close();
      });
    }

    toggle() {
      this.hasAttribute('data-open') ? this.close() : this.open();
    }

    open() {
      this.setAttribute('data-open', '');
      this.list.hidden = false;
      this.trigger.setAttribute('aria-expanded', 'true');
    }

    close() {
      this.removeAttribute('data-open');
      this.list.hidden = true;
      this.trigger.setAttribute('aria-expanded', 'false');
    }

    select(option) {
      const value = option.dataset.value;
      const image = option.dataset.image;

      this.list.querySelectorAll('[data-option]').forEach((el) => el.classList.remove('is-selected'));
      option.classList.add('is-selected');

      this.value.textContent = value;
      this.dot.style.setProperty('--dot-color', value.toLowerCase());
      this.close();

      const row = this.closest('[data-bundle-row]');

      const property = row?.querySelector('[data-bundle-property]');
      if (property) property.value = value;

      const thumb = row?.querySelector('[data-bundle-thumb]');
      if (thumb && image) thumb.src = image;

      if (row?.hasAttribute('data-drives-variant-picker')) {
        BundleSwatchSelect.syncMainVariantPicker(this, value);
      }

      this.dispatchEvent(new CustomEvent('bundle-swatch:change', { bubbles: true, detail: { value, image } }));
    }

    static syncMainVariantPicker(el, value) {
      const section = el.closest('.shopify-section');
      const variantPicker = section?.querySelector('variant-picker');
      if (!variantPicker) return;

      const inputs = variantPicker.querySelectorAll('input[type="radio"], option');
      for (const input of inputs) {
        const inputValue = input.value || input.getAttribute('value');
        if (inputValue === value) {
          if (input.tagName === 'OPTION') {
            input.selected = true;
            input.parentElement.dispatchEvent(new Event('change', { bubbles: true }));
          } else if (!input.checked) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
            input.click();
          }
          break;
        }
      }
    }
  }

  customElements.define('bundle-swatch-select', BundleSwatchSelect);
})();
